import MaterialTable, { Query, QueryResult } from "@material-table/core";
import { ReportService } from "../../../services/SubmissionService";
import { SubmissionService } from "../../../services/SubmissionService";
import * as APIModels from "../../../models";
import { useEffect, useRef, useState } from "react";
import FailModal from "./modals/FailModal";
import { Box, TableSortLabel } from "@mui/material";
export default function DailyReportWidget() {
    const [organization, setOrganization] = useState(
        new APIModels.Organization()
    );

    type NameValueOptionType = { label: string; value: string };
    const [submissionIdToFail, setSubmissionIdToFail] = useState("");
    const options: NameValueOptionType[] = [];

    const [failModalShow, setFailModalShow] = useState(false);
    const [data, setData] = useState({} as ReportData);
    interface ReportData {
        data: APIModels.ReportSubmission[];
        page: number;
        totalCount: number;
    }
    const [searchString, setSearchString] = useState("");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(5);
    const [orderBy, setOrderBy] = useState("");
    const [orderDirection, setOrderDirection] = useState("");
    const [row, setRow] = useState(new APIModels.ReportSubmission());
    const [refresh, setRefresh] = useState(false);
    const [loading, setLoading] = useState(false);

    /*
	const fail = (submissionId: string, reason: string, details: string) => {
		setLoading(true);
		console.log("FAIL REASON " + reason + "  " + details);
		SubmissionService.fail({
			submissionId: submissionIdToFail,
			body: { defaultMessage: parseInt(reason), message: details },
		}).then(
			(resp) => {
				console.log("success");

				setLoading(false);
				setRefresh(!refresh);
			},
			(error) => {
				console.log(error);
				setLoading(false);
			}
		);
	};
	*/

    // Hard Coded message
    const fail = () => {
        setLoading(true);

        SubmissionService.fail({
            submissionId: submissionIdToFail,
            body: { defaultMessage: 6, message: "" },
        }).then(
            (resp) => {
                console.log("success");

                setLoading(false);
                setRefresh(!refresh);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );
    };

    const getRowId = (rowData: APIModels.ReportSubmission) => {
        setSubmissionIdToFail(rowData.submissionID!);
        console.log("SUBBBBB = " + rowData.submissionID!);
        /*
		Object.entries(rowData).map((v, i, j) => {
			if (v[0] == "submissionID") {
				setSubmissionIdToFail(v[1] as string);
			}
		});
		*/
    };

    useEffect(() => {
        setLoading(true);
        ReportService.getSubmissionsToday({
            pageNumber: page,
            itemsPerPage: pageSize,
            searchString: searchString,
            orderBy: orderBy, //query.orderBy != undefined ? query.orderBy.field : "",
            orderDirection: orderDirection ?? "",
        }).then(
            (resp) => {
                setData({
                    data: resp.data as any,
                    page: (resp.currentPage ?? 1) - 1,
                    totalCount: resp.totalCount ?? 0,
                });
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
                //setError(error);
            }
        );
    }, []);

    useEffect(() => {
        setLoading(true);
        ReportService.getSubmissionsToday({
            pageNumber: page,
            itemsPerPage: pageSize,
            searchString: searchString,
            orderBy: orderBy,
            orderDirection: orderDirection,
        }).then(
            (resp) => {
                setData({
                    data: resp.data as any,
                    page: (resp.currentPage ?? 1) - 1,
                    totalCount: resp.totalCount ?? 0,
                });
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
                //setError(error);
            }
        );
    }, [searchString, page, pageSize, orderBy, orderDirection, refresh]);

    return (
        <Box sx={{ width: "100%", padding: 0 }}>
            <FailModal
                show={failModalShow}
                onFail={() => {
                    setFailModalShow(false);
                    fail();
                }}
                onCancel={() => setFailModalShow(false)}
            />
            <div className="card-body">
                <MaterialTable
                    columns={[
                        {
                            title: "SubmissionId",
                            field: "submissionID",
                            hidden: true,
                            type: "string",
                        },
                        { title: "Filename", field: "filename" },
                        {
                            title: "Case Number",
                            field: "caseNumber",
                        },
                        {
                            title: "Matter Number",
                            field: "matterNumber",
                        },
                        {
                            title: "Status",
                            field: "statusDescription",
                        },
                        {
                            title: "Filing Attorney",
                            field: "attorneyName",
                        },
                        {
                            title: "Reference Number",
                            field: "referenceNumber",
                        },
                        {
                            title: "Time Uploaded",
                            field: "uploadedDateTime",
                        },
                        {
                            title: "Time Filed",
                            field: "filedDateTime",
                        },
                    ]}
                    page={data.page}
                    totalCount={data.totalCount}
                    data={data.data}
                    isLoading={loading}
                    options={{
                        sorting: true,
                        search: true,
                        loadingType: "overlay",
                    }}
                    onPageChange={(page: number, pageSize: number) => {
                        console.log("onChangePage " + page);
                        setPage(page + 1);
                        setPageSize(pageSize);
                    }}
                    onRowsPerPageChange={(pageSize: number) => {
                        setPageSize(pageSize);
                    }}
                    onSearchChange={(searchText: string) => {
                        console.log("onSearchChange " + searchText);
                        setSearchString(searchText);
                    }}
                    actions={[
                        (rowData) => ({
                            tooltip:
                                rowData.statusDescription == "Parsed"
                                    ? "Fail Filing"
                                    : "",
                            icon:
                                rowData.statusDescription == "Parsed"
                                    ? "cancel"
                                    : "blank",
                            disabled:
                                rowData.statusDescription == "Parsed"
                                    ? false
                                    : true,
                            onClick: (event, rowData) => {
                                getRowId(rowData as APIModels.ReportSubmission);
                                setFailModalShow(true);
                            },
                        }),
                        {
                            icon: "refresh",
                            tooltip: "Resfresh Data",
                            isFreeAction: true,
                            onClick: (event) => {
                                setRefresh(!refresh);
                            },
                        },
                    ]}
                    title="e-Filings Today"
                />
            </div>
        </Box>
    );
}
